'use client';

import { useLanguage } from '@/contexts/language-context';

interface VAgentLogoProps {
  onClick?: () => void;
}

export default function VAgentLogo({ onClick }: VAgentLogoProps) {
  const { isRTL } = useLanguage();

  return (
    <button
      onClick={() => {
        window.open('https://aifo.com', '_blank', 'noopener,noreferrer');
        onClick?.();
      }}
      style={{
        position: 'fixed',
        top: 18,
        left: isRTL ? 'auto' : 16,
        right: isRTL ? 16 : 'auto',
        zIndex: 60,
      }}
      className="cursor-pointer hover:opacity-80 transition-opacity p-0 overflow-visible">
      <img
        src="/logo.svg"
        alt="AIFO-Coach"
        className="h-[28px] w-[108px] block"
      />
    </button>
  );
}
